import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, map } from 'rxjs';

import { CartaoCredBandeira } from 'src/app/shared/models/cartao-cred-bandeira';
import { CartaoCredBandeirasService } from './../../../../core/services/http/cartao-cred-bandeiras.service';
import { MudarFocoService } from 'src/app/core/services/behavior/mudar-foco.service';
import { HelpersUtil } from 'src/app/shared/utils/helpers.util';

@Component({
  selector: 'app-area-cartao',
  templateUrl: './area-cartao.component.html',
  styleUrls: ['./area-cartao.component.css']
})
export class AreaCartaoComponent implements OnInit, OnDestroy {
  private _subs$: Subscription[] = [];

  public bandeiraCartaoSelecionada: CartaoCredBandeira;
  public bandeirasCartao: CartaoCredBandeira[] = [];

  constructor(
    private _cartaoCredBandeirasService: CartaoCredBandeirasService,
    private _mudarFocoService: MudarFocoService
  ) { }

  public mudarFocoOnKeydownEnter() {
    this._mudarFocoService.mudarFoco$.next(true);
  }

  public ngOnDestroy(): void {
    this._subs$.forEach(sub$ => sub$.unsubscribe());
  }

  public ngOnInit() {
    const obs$ = this._cartaoCredBandeirasService.obterCartaoCredBandeiras().pipe(
      map(l => l.success ? l.data : [])
    );

    const sub$ = obs$.subscribe(res => {
      this.bandeirasCartao = res;

      this._definirValorPadraoBandeiraCartaoSelecionada();

      this._definirFocoNaPrimeiraBandeira();
    });

    this._subs$.push(sub$);
  }

  public selecionouBandeiraCartaoOnChange(bandeiraCartao: CartaoCredBandeira) {
    this.bandeiraCartaoSelecionada = bandeiraCartao;
  }

  /**
   * É necessário fazer isso, pois o evento OnChange só é acionado quando há interação do usuário com o rádio.
   */
  private _definirValorPadraoBandeiraCartaoSelecionada() {
    this.bandeiraCartaoSelecionada = this.bandeirasCartao[0];
  }

  private _definirFocoNaPrimeiraBandeira() {
    HelpersUtil.executeAfterDelay(() => {
      const primeiraBandeira = document.getElementById('bandeira0');
      primeiraBandeira.focus();
    });
  }
}
